import { SELECTED_PROJECT } from "../configuration";
import { getEnvType } from "../helpers";

function getDevBackendPort() {
  switch (SELECTED_PROJECT) {
    case "alicia":
      return "8083";
    case "r3-mydas":
      return "8082";
    case "alliance":
      return "8080";
    default:
      throw new Error("Unknown project name");
  }
}
// Backend URL
// const BASE_URL =
// 	getEnvType() === "dev"
// 		? "http://localhost"
// 		: `https://marketplace-backend.${SELECTED_PROJECT}.rid-intrasoft.eu`;

const BASE_URL = `https://marketplace-backend.${SELECTED_PROJECT}.rid-intrasoft.eu`;

// const BACK_END_PORT = getEnvType() === "dev" ? getDevBackendPort() : "8083";
// export const BACK_END_URL =
// 	getEnvType() === "dev"
// 		? `${BASE_URL}:${BACK_END_PORT}/api`
// 		: `${BASE_URL}/api`;

export const BACK_END_URL = `${BASE_URL}/api`;

// Asset URL
// const ASSET_BASE_URL =
// 	getEnvType() === "dev"
// 		? "http://localhost"
// 		: `https://asset-handler.${SELECTED_PROJECT}.rid-intrasoft.eu`;

const ASSET_BASE_URL = `https://asset-handler.${SELECTED_PROJECT}.rid-intrasoft.eu`;

const ASSET_PORT = "8085";
const ASSET_VERSION = "v1";
// export const ASSET_URL =
// 	getEnvType() === "dev"
// 		? `${ASSET_BASE_URL}:${ASSET_PORT}/api/${ASSET_VERSION}/asset`
// 		: `${ASSET_BASE_URL}/api/${ASSET_VERSION}/asset`;

export const ASSET_URL = `${ASSET_BASE_URL}/api/${ASSET_VERSION}/asset`;

export const ASSET_API_TOKEN = "550e8400-e29b-41d4-a716-446655440000";

export const API_VERSION = "v1";

export const RANKINGS_PORT = "8086";
// export const RANKINGS_URL =
// 	getEnvType() === "dev"
// 		? `${BASE_URL}:${RANKINGS_PORT}`
// 		: "https://orchestrator-ai-ds-dt.alicia.rid-intrasoft.eu";

export const RANKINGS_URL =
  "https://orchestrator-ai-ds-dt.alicia.rid-intrasoft.eu";

export const ENDPOINTS = {
  SOCIAL_MEDIA: "social-media",
};

export const ENDPOINT_BASE = {
  APP_CONFIGURATION: "/app-configuration",
  USER: "/user",
  PRODUCT: "/product",
  CATEGORY: "/category",
  ORDER: "/order/",
  ORDER_ITEM: "/order-item/",
  RATING: "/rating/",
  RANKING: "/ranking/",
  REVIEW: "/review/",
  SOCIAL_MEDIA: "/social-media",
  ASSET: "/asset/",
  MANUFACTURER: "/manufacturer",
  TAG: "/tag",
  HISTORICAL_DATA: "/historical-data",
  PRODUCT_WORKER_SKILLS: "/product-worker-skills",
  WORKER_SKILLS_REQUEST: "/worker-skills-request",
  PRODUCT_PROPERTY: "/product-property",
  INSTALLATION_REQUIREMENTS: "/installation-requirements",
  PROCESSING_INFO: "/processing-info",
  AI_DS_DT_REQUEST: "/factory-owner-requirements-request",
  PROPERTY: "/property",
  CART: "/cart",
  IMAGE: "/image",
  EQUIPMENT_CAPABILITIES: "/product-capabilities",
  THIRD_PARTY_SERVICES: "/third-party-services",
  EXTERNAL_PRODUCT_RECORDS: "/external-product-records",
  PRODUCT_REQUEST_PROPERTY: "/product-request-property",
  PRODUCT_REQUEST_CAPABILITIES: "/capabilities-request",
  PRODUCT_ENVIRONMENTAL_PROPERTIES: "/environmental-properties",
  PRODUCTION_PHASE_SUPPORT_REQUEST: "/production-phase-support-request",
  PRODUCT_CONNECTION_CAPABILITIES: "/product-connection-capability",
  PROCESSING_AND_INSTALLATION_REQUEST: "/processing-and-installation-request",
  KPI_SELECTION_REQUEST: "/kpi-selection-request",
  OPERATION_REQUEST: "/matchmaking-operation",
  OPERATION_GROUP: "/matchmaking-operation-group",
  INCUMBENT_REQUEST: "/incumbent-equipment-request",
  SYSTEMIC_INNOVATION: "/systemic-innovation",
  URL: "/url",
  RESOURCE_GROUP: "/resource-group",
};
